"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const _1 = __importDefault(require("."));
const SurveyList = ({ surveys, onComplete }) => {
    const [availableSurveys, setAvailableSurveys] = (0, react_1.useState)(surveys.filter(({ taken_survey }) => !taken_survey));
    const [showNextMsg, setShowNextMsg] = (0, react_1.useState)('');
    const currentSurvey = availableSurveys[0];
    if (availableSurveys.length === 0) {
        return null;
    }
    const handleSurveyComplete = () => {
        const remainingSurveys = availableSurveys.filter(({ id }) => id !== currentSurvey.id);
        setAvailableSurveys(remainingSurveys);
        setShowNextMsg(remainingSurveys.length > 0 ? 'There is another survey available to you.' : '');
        const container = document.getElementById('survey-list-container');
        container.scrollIntoView({ behavior: 'smooth', block: 'start' });
        onComplete?.({ remainingSurveys });
    };
    return (react_1.default.createElement("div", { id: "survey-list-container" },
        showNextMsg && react_1.default.createElement("p", null, showNextMsg),
        react_1.default.createElement("div", { key: currentSurvey.id },
            react_1.default.createElement(_1.default, { allowRepeatEntries: false, element: "embed", onSubmit: handleSurveyComplete, surveyJson: currentSurvey.content, surveySlug: currentSurvey.survey_slug, version: currentSurvey.version }))));
};
exports.default = SurveyList;
